var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"check-list-delete auto-list_col_centered"},[_c('div',[_c('el-button',{attrs:{"type":"danger","icon":"el-icon-delete","circle":""},on:{"click":_vm.openDialog}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }